import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-progress-info-popup',
  templateUrl: './progress-info-popup.component.html',
  styleUrls: ['./progress-info-popup.component.scss']
})
export class ProgressInfoPopupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ProgressInfoPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  closeDialog() {
    this.dialogRef.close();
  }

}
